/**
 * 全能拆分限免池判定与扣减记账映射（纯函数，TB-9531）
 *
 * UI 展示模式组装在 views/.../GameUiSplitterPanel/splitQuotaRules.ts（含文案与 blocked 判定）；
 * 本文件只服务 user store 的乐观扣减/回滚记账：限免命中时按池扣 1 次、终态按池核销/回退。
 * 池语义：trial=未付费免费体验（永久）；total=会员累计限免（永久）；daily=会员每日限免（次日重置）。
 * 会员消耗顺序=先累计后每日（与后端一致），回滚必须退回扣减时的池子，防跨日场景虚增。
 */

export type GameUiSplitQuotaKind = "gameUiSplitTrial" | "gameUiSplitTotal" | "gameUiSplitDaily";

/** kind → sources 计数字段名 */
export const GAME_UI_SPLIT_POOL_COUNT_KEYS: Record<
  GameUiSplitQuotaKind,
  "gameUiSplitTrialCount" | "gameUiSplitTotalCount" | "gameUiSplitDailyCount"
> = {
  gameUiSplitTrial: "gameUiSplitTrialCount",
  gameUiSplitTotal: "gameUiSplitTotalCount",
  gameUiSplitDaily: "gameUiSplitDailyCount"
};

export function isGameUiSplitQuotaKind(kind: string): kind is GameUiSplitQuotaKind {
  return kind in GAME_UI_SPLIT_POOL_COUNT_KEYS;
}

/** 按展示规则选本次扣减的池：未付费扣体验池；会员 Beta 开且先累计后每日；null=不命中限免 */
export function pickGameUiSplitQuotaPool(
  sources: {
    gameUiSplitBetaEnabled: boolean;
    gameUiSplitTrialCount: number;
    gameUiSplitTotalCount: number;
    gameUiSplitDailyCount: number;
  },
  isMember: boolean
): GameUiSplitQuotaKind | null {
  if (!isMember) {
    // 未付费用户：免费体验池永久有效，不受 Beta 开关影响
    return sources.gameUiSplitTrialCount > 0 ? "gameUiSplitTrial" : null;
  }
  if (!sources.gameUiSplitBetaEnabled) return null;
  if (sources.gameUiSplitTotalCount > 0) return "gameUiSplitTotal";
  if (sources.gameUiSplitDailyCount > 0) return "gameUiSplitDaily";
  return null;
}
